import React, { Component } from 'react';
import { connect } from 'react-redux'
import { compose } from 'redux';
import { formValueSelector, Field, reduxForm } from 'redux-form'
import PropTypes from 'prop-types'
import * as Validate from '../../helpers/validations'

// constants

//Components
import { Row, Col } from 'react-flexbox-grid';
import Button from '../../components/Button'
import SignUpError from './components/SignUpError'
import Textfield from './components/Textfield'
import BackgroundImage from '../../components/BackgroundImage'
import { interceptor } from '../../services/interceptor-service';

//Styles
import signUpStyles from './styles/signUp.module.scss'
import { appSignUp, appLogin, socialLogin, sendWelcomeEmail, clearUserState } from '../../actions/user-actions';

class SignUp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isPasswordVisible: false,
      isPasswordConfirmationVisible: false,
      errorLoginSocial: false,
      errorLabel: ''
    }
  }

  viewPassword = () =>
    this.setState({
      isPasswordVisible: !this.state.isPasswordVisible
    })

  viewConfirmPassword = () =>
    this.setState({
      isPasswordConfirmationVisible: !this.state.isPasswordConfirmationVisible
    })

  componentDidMount() {
    this.props.clearState();
  }

  componentDidUpdate(prevProps) {
    if (this.props.appSignupError && !prevProps.appSignupError && !this.props.loading) {
      this.setState({
        errorLabel: this.props.errorMessage
      })
    }

    if (this.props.appSignupError && prevProps.email !== this.props.email) {
      this.setState({
        errorLabel: ''
      })
    }

    if (this.props.appSignupSuccess && !prevProps.appSignupSuccess) {
      localStorage.setItem('user', JSON.stringify(this.props.user));
      this.props.sendWelcomeEmail({
        to: this.props.user.email,
        username: this.props.user.name
      });
    }

    if (this.props.sendWelcomeEmailSuccess && !prevProps.sendWelcomeEmailSuccess) {
      window.location.href = "/main/calendar";
    }

    if (this.props.socialLoginSuccess && !prevProps.socialLoginSuccess ) {
      if (this.props.user.token){
        interceptor.addToken(this.props.user.token);
        localStorage.setItem('menu', 'calendar');
        localStorage.setItem('user', JSON.stringify(this.props.user.user));
        window.location.href = '/main/calendar';
      }
      else{
        this.setState({
          errorLoginSocial: true,
        })
      }
    }
  }

  onSubmit = ({email, name, password}) => {
    let userData = {
      email,
      name,
      password
    }

    this.props.appSignup(userData);
  }

  responseFacebook = (response) => {
    if (response){
      let data = {
        email: response.email,
        sortKey: 'facebook',
        name: response.name,
        profilePicture: response.picture.data.url
      }
      this.props.socialLogin(data)
    }
  }

  responseGoogle = (response) => {
    if (response.accessToken) {
      let data = {
        email: response.profileObj.email,
        sortKey: 'google',
        name: response.profileObj.name,
        profilePicture: response.profileObj.imageUrl
      }
      this.props.socialLogin(data)
    }
  }

  render() {
    const { isPasswordVisible, isPasswordConfirmationVisible } = this.state
    const passwordType = isPasswordVisible ? 'text' : 'password';
    const confirmPasswordType = isPasswordConfirmationVisible ? 'text' : 'password';
    //const { handleSubmit, pristine, submitting, invalid, responseGoogle, responseFailGoogle, responseFacebook} = this.props;
    const { handleSubmit, pristine, submitting, invalid } = this.props;
    return (
      <BackgroundImage form active={this.props.showLoading} signup={true}>
        <Row center="xs">
          <Col xs={10}>
            <Row center="xs" className={signUpStyles.__wrapper}>
                  <img src="/images/logo.png" className={signUpStyles.__logo} alt="Liveli Logo"/>
                  <Col xs={12}>
                    <span className={signUpStyles.__title}>
                      Sign Up
                    </span>
                  </Col>
                  <Col xs={12}>
                    <p>
                      Create your account
                    </p>
                  </Col>
                  <Col xs={10}>
                {/*  <SocialLoginButton
                    btnType={'google'}
                    onClickSocial={this.responseGoogle}
                    //onClickFailGoogle={responseFailGoogle}
                  />
                  <SocialLoginButton
                    btnType={'facebook'}
                    onClickSocial={this.responseFacebook}
                  />
                    <div className={signUpStyles.__divider}>
                      <div className={signUpStyles.__divider_line}> </div>
                      {
                        !this.state.errorLoginSocial ?
                        <span className={signUpStyles.__divider__text}>
                          Or sign up via
                        </span> :
                        <span className={signUpStyles.__divider__text} style={{color: 'red'}}>
                          Error in login, try again.
                        </span>
                      }
                    </div> */}
                    <form onSubmit={handleSubmit(this.onSubmit)}>
                      <Field
                          name="name"
                          props={{
                            input_type: 'text',
                            label: 'Full Name',
                            loginView: true
                          }}
                          component={Textfield}
                          validate={[Validate.required]}
                        />

                        <Field
                          name="email"
                          label="email"
                          props={{
                            input_type: 'text',
                            label: 'Email Address',
                            loginView: true
                          }}
                          component={Textfield}
                          validate={[Validate.required, Validate.email]}
                        />

                        <Field
                          name="password"
                          props={{
                            viewPassword: true,
                            input_type: passwordType,
                            label: 'Password',
                            viewPassword_press: this.viewPassword,
                            viewPassword_icon: this.state.isPasswordVisible ? 'eyeoff' : 'eye',
                            showTooltip: true,
                            id: 'password',
                            loginView: true
                          }}
                          component={Textfield}
                          validate={[Validate.required, Validate.minLength8, Validate.maxLength16, Validate.password]}
                        />

                        <Field
                          name="confirmPassword"
                          props={{
                            viewPassword: true,
                            input_type: confirmPasswordType,
                            label: 'Confirm Password',
                            viewPassword_press: this.viewConfirmPassword,
                            viewPassword_icon: this.state.isPasswordConfirmationVisible ? 'eyeoff' : 'eye',
                            loginView: true
                          }}
                          component={Textfield}
                          validate={[Validate.passwordMatch, Validate.required]}
                        />
                        <Button type='submit' disabled={invalid|| submitting || pristine} login label="sign up" />
                      </form>
                      {this.props.appSignupError && this.state.errorLabel &&
                        (
                              <SignUpError label={this.state.errorLabel} />
                        )}
                      <p className={signUpStyles.__link}>
                        Already have an account?
                        <a href="/"> Log in</a>
                      </p>
                  </Col>
            </Row>
          </Col>
        </Row>
      </BackgroundImage>
    )
  }
}

const form = reduxForm({
  form: 'signUp'
});

SignUp.propTypes = {
  appSignup: PropTypes.func,
  appLogin: PropTypes.func,
  socialLogin: PropTypes.func,
  history: PropTypes.object,
  email: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  appSignupError: PropTypes.bool,
  appSignupSuccess: PropTypes.bool,
  errorStatus: PropTypes.number,
  errorMessage: PropTypes.string,
  user: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  token: PropTypes.string,
  clearState: PropTypes.func.isRequired
}

const mapStateToProps = (state) => {
const selector = formValueSelector('signUp');
  return {
    email: selector(state, 'email'),
    password: selector(state, 'password'),
    user: state.userReducer.user,
    errorType: state.userReducer.errorStatus,
    appSignupError: state.userReducer.appSignupError,
    appSignupSuccess: state.userReducer.appSignupSuccess,
    socialLoginSuccess: state.userReducer.socialLoginSuccess,
    socialLoginError: state.userReducer.socialLoginError,
    sendWelcomeEmailSuccess: state.userReducer.sendWelcomeEmailSuccess,
    errorMessage: state.userReducer.errorMessage,
    token: state.userReducer.token,
    loading: state.userReducer.loading,
    showLoading: state.loadingReducer.showLoading
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    socialLogin: (userData) => dispatch(socialLogin(userData)),
    appSignup: (userData) => dispatch(appSignUp(userData)),
    appLogin: (userData) => dispatch(appLogin(userData)),
    sendWelcomeEmail: (data) => dispatch(sendWelcomeEmail(data)),
    clearState: () => dispatch(clearUserState())
  }
}

export default compose(
  form,
  connect(
    mapStateToProps,
    mapDispatchToProps)
)(SignUp)
